export default {

	STOP: 'stop',
	START: 'start'
};
